<template>
    <v-btn block style="height:200px;" :disabled="isAvailable" @click="daySelected" :color="color">
    <div>
    <h1>{{calendarText}}</h1>
    <h3>{{dayTextLang}}</h3>
    </div>
    </v-btn>
</template>


<script>
    import  { Logger } from 'aws-amplify';
    const logger = new Logger('DaySelectHelper','INFO');
    import { AmplifyEventBus } from 'aws-amplify-vue'
    import moment from 'moment-timezone'

    export default {
        name:"CheckoutHelper",
        created() {

        },
        beforeDestroy () {
            logger.info("Home beforeDestroy")

        },
        props: {
            /*
            businessHours:{
                type:Object,
                default: null
            },

             */
            keyNum:{
                type:Number,
                default:undefined
            },
            serviceType:{
                type:String,
                default:"adt"
            },
            color:{
                type:String,
                default:"default"
            }

        },
        watch: {

        },

        computed:{
            businessHours(){
                return this.$store.getters.businessHours(moment())
            },
            calendarText(){
                let res
                if( this.businessHours
                    && this.businessHours[this.serviceType]
                    && this.businessHours[this.serviceType].days
                    && this.businessHours[this.serviceType].days[this.keyNum]
                    && this.businessHours[this.serviceType].days[this.keyNum].calendarText){
                    res =  this.businessHours[this.serviceType].days[this.keyNum].calendarText
                }
                return res
            },
            dayTextLang(){
                let res
                if( this.businessHours
                    && this.businessHours[this.serviceType]
                    && this.businessHours[this.serviceType].days
                    && this.businessHours[this.serviceType].days[this.keyNum]
                    && this.businessHours[this.serviceType].days[this.keyNum].dayTextLang){
                    res = this.businessHours[this.serviceType].days[this.keyNum].dayTextLang
                }
                return res
            },
            isAvailable() {
                if( this.businessHours
                    && this.businessHours[this.serviceType]
                    && this.businessHours[this.serviceType].days
                    && this.businessHours[this.serviceType].days[this.keyNum]
                    && this.businessHours[this.serviceType].days[this.keyNum].isBusinessDay){
                    //logger.info("businessHours: "+this.keyNum,this.businessHours[this.serviceType].days[this.keyNum])
                    //logger.info("isBusinessDay",this.businessHours[this.serviceType].days[this.keyNum].isBusinessDay)
                    return false
                }else{
                    return true
                }
            }
        },
        methods:{
            daySelected(){
                const dataToEmit = {}
                dataToEmit.dayTextLang = this.businessHours[this.serviceType].days[this.keyNum].dayTextLang
                dataToEmit.dayText = this.businessHours[this.serviceType].days[this.keyNum].dayText
                dataToEmit.keyNum = this.keyNum
                logger.info("daySelected",dataToEmit)
                AmplifyEventBus.$emit('daySelected', dataToEmit )
            }
        }
    }
</script>